module.exports = __webpack_public_path__ + "static/media/feature-collab.91a2d1b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonusView/feature-collab.svg
// module id = 477
// module chunks = 0